// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductOption-module__list___3tUz2","item":"ProductOption-module__item___17VjJ","price":"ProductOption-module__price___Q979K"};